import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashPaymentBag1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "Modified SVG" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.08325 14.25V23.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.08325 21.75H17.5833C17.5833 20.9544 17.2672 20.1913 16.7046 19.6287C16.142 19.0661 15.3789 18.75 14.5833 18.75H10.8333C10.8333 17.9544 10.5172 17.1913 9.95457 16.6287C9.39196 16.0661 8.6289 15.75 7.83325 15.75H1.08325"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.08325 18.75H10.8333"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.5733 18.008C21.6631 17.1962 22.5111 16.1025 23.0258 14.8447C23.5406 13.587 23.7028 12.2127 23.4948 10.8696C23.2869 9.52659 22.7167 8.26566 21.8456 7.22246C20.9746 6.17926 19.8356 5.39326 18.5513 4.94902L20.4043 1.77902C20.4653 1.67485 20.4975 1.55628 20.4975 1.43552C20.4975 1.31476 20.4653 1.19619 20.4043 1.09202C20.3409 0.98687 20.2512 0.900037 20.1441 0.840069C20.0369 0.780102 19.916 0.749068 19.7933 0.750021H12.3733C12.2508 0.749415 12.1303 0.780615 12.0236 0.840566C11.9168 0.900516 11.8275 0.987163 11.7643 1.09202C11.7032 1.19619 11.671 1.31476 11.671 1.43552C11.671 1.55628 11.7032 1.67485 11.7643 1.77902L13.6173 4.94902C12.15 5.45626 10.877 6.40764 9.97496 7.67113C9.0729 8.93462 8.5865 10.4476 8.58325 12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.0333 13.844C14.2498 14.1284 14.5318 14.3565 14.8552 14.5088C15.1786 14.6611 15.534 14.7332 15.8913 14.719C17.0303 14.719 17.9543 14.026 17.9543 13.172C17.9543 12.318 17.0303 11.626 15.8913 11.626C14.7523 11.626 13.8333 10.933 13.8333 10.078C13.8333 9.223 14.7573 8.531 15.8953 8.531C16.2525 8.51652 16.608 8.58851 16.9315 8.74084C17.2549 8.89318 17.5369 9.12136 17.7533 9.406"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.8953 14.719V15.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.8953 7.5V8.531"
		})
	]
});
export default SvgCashPaymentBag1;
